module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    attrs: {
      "id": "sigil_toc_id_2",
      "title": "Title Page"
    }
  }, [_vm._v("J. B. Lightfoot"), _c('br')]), _vm._v(" "), _c('h1', {
    staticClass: "sigil_not_in_toc"
  }, [_vm._v("The Gospel of St. John")]), _vm._v(" "), _c('h2', {
    staticClass: "sigil_not_in_toc"
  }, [_vm._v("A Newly Discovered Commentary")]), _vm._v(" "), _c('h5', {
    staticClass: "sigil_not_in_toc"
  }, [_vm._v("The Lightfoot Legacy set")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    staticClass: "img10",
    attrs: {
      "alt": "49077.jpg",
      "src": "Images/49077.jpg"
    }
  })]), _vm._v(" "), _c('p', [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('i', [_vm._v("Volume 2")])]), _vm._v(" "), _c('p', [_c('br')]), _vm._v(" "), _c('h3', {
    staticClass: "center sigil_not_in_toc"
  }, [_c('i', [_vm._v("Edited by")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Ben Witherington III")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('i', [_vm._v("and")]), _vm._v(" Todd D. Still")]), _vm._v(" "), _c('h3', {
    staticClass: "center sigil_not_in_toc"
  }, [_c('i', [_vm._v("Assisted by")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Jeanette M. Hagen")]), _vm._v(" "), _c('div', {
    staticClass: "photo"
  }, [_c('a', {
    attrs: {
      "href": "http://www.ivpress.com/academic",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "alt": "IVP_Academic_Colophon.png",
      "src": "Images/IVP_Academic_Colophon.png"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-55af9e88","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/title.vue
// module id = 57
// module chunks = 0